import CrudCustom from '../../../libs/custom/CrudCustom';


let SandingPPh21AkunService = new CrudCustom('/sanding-pph21-akuns');
export default SandingPPh21AkunService;
